import { useState } from "react";

interface Props {
  label?: string;
  keywords: string[];
  setKeywords: React.Dispatch<React.SetStateAction<string[]>>;
  inputClassName?: string;
  labelClassName?: string;
  containerClassname?: string;
  placeholder?: string;
  error?: boolean;
}

export const TagInput = ({
  label,
  keywords,
  setKeywords,
  inputClassName,
  labelClassName,
  placeholder = "Type and press enter to add keywords",
  error,
  containerClassname,
}: Props) => {
  /** State */
  const [inputValue, setInputValue] = useState("");

  /** Callbacks */
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && inputValue.trim()) {
      e.preventDefault();
      if (!keywords.includes(inputValue.trim())) {
        setKeywords([...keywords, inputValue.trim()]);
        setInputValue("");
      }
    }
  };

  const removeKeyword = (indexToRemove: number) => {
    setKeywords(keywords.filter((_, index) => index !== indexToRemove));
  };

  return (
    <div className={`mb-4 ${containerClassname}`}>
      <label
        className={`font-satoshi text-dark text-sm font-medium mb-3 ${labelClassName}`}
      >
        {label}
      </label>
      <div className="border border-gray-300 rounded-md p-2">
        {keywords?.length ? (
          <div className="flex flex-wrap gap-2 mb-2">
            {keywords.map((keyword, index) => (
              <span
                key={index}
                className="bg-green-100 text-green-800 px-2 py-1 rounded-md flex items-center"
              >
                {keyword}
                <button
                  type="button"
                  onClick={() => removeKeyword(index)}
                  className="ml-2 text-green-600 hover:text-green-800"
                >
                  ×
                </button>
              </span>
            ))}
          </div>
        ) : null}
        <input
          type="text"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          // className="w-full p-1 focus:outline-none"
          className={`w-full h-[46px] px-4 bg-sky-lighter border ${
            error ? "border-red-base" : "border-gray-border"
          } ${
            error ? "focus:border-red-base" : "focus:border-focused-border"
          } rounded font-satoshi text-base text-dark font-medium outline-none ${inputClassName}`}
          placeholder={placeholder}
        />
      </div>
    </div>
  );
};
